import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * a wrapper around stripe in order to delay and isolate loading the particular stripe-js code
 * @param args
 */
export var loadStripe = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var stripe,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import( /* webpackChunkName: "stripe-js", webpackPrefetch: true */'@stripe/stripe-js');
        case 2:
          stripe = _context.sent;
          return _context.abrupt("return", stripe.loadStripe.apply(stripe, _args));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadStripe() {
    return _ref.apply(this, arguments);
  };
}();